import { Component, Input } from '@angular/core';
import { ContactMethod, ContactMethodDisplayOptions } from '../models/contact-method.model';

@Component({
  selector: 'contact-methods',
  styles: [require('./contact-methods.component.scss')],
  template: require('./contact-methods.component.html'),
})

export class ContactMethodsComponent {
  @Input() contactMethods: ContactMethod[] = [];
  @Input() numbered: boolean = true;
  @Input() showShared: boolean = false;
  @Input() showIcon: boolean = false;
  @Input() numberDisplay: ContactMethodDisplayOptions = 'inline';
  @Input() splittedDisplay: boolean = false;
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/contact-methods/contact-methods.component.ts